import { listCategories } from '../api-client';

interface PickerOpts {
  kind?: 'expense' | 'income';
  exclude?: string[];
  currentCategoryId?: string;
  currentSubcategoryId?: string | null;
}

export async function showCategoryPicker(
  onPick: (categoryId: string, subcategoryId: string | null) => void,
  opts?: PickerOpts,
): Promise<void> {
  const { categories } = await listCategories();
  const filtered = (opts?.kind ? categories.filter((c) => c.kind === opts.kind) : categories)
    .filter((c) => !opts?.exclude?.includes(c.id));
  const tops = filtered.filter((c) => c.parentId === null);
  const kids = filtered.filter((c) => c.parentId !== null);

  const backdrop = document.createElement('div');
  backdrop.className = 'picker-backdrop';
  backdrop.innerHTML = `<div class="picker">
    <header class="picker-header">
      <h3>Pick a category</h3>
    </header>
    <div class="picker-list"></div>
    <button id="picker-close" class="picker-close-btn">Cancel</button>
  </div>`;
  document.body.appendChild(backdrop);

  const list = backdrop.querySelector<HTMLElement>('.picker-list')!;
  let firstCurrentRow: HTMLElement | null = null;

  function applyCurrent(el: HTMLElement, label: string, isCurrent: boolean): void {
    if (isCurrent) {
      el.classList.add('picker-current');
      el.textContent = `✓ ${label}`;
      if (!firstCurrentRow) firstCurrentRow = el;
    } else {
      el.textContent = label;
    }
  }

  for (const top of tops) {
    const topEl = document.createElement('button');
    topEl.className = 'picker-item';
    const isCurrentParent =
      opts?.currentCategoryId === top.id &&
      (opts?.currentSubcategoryId == null);
    applyCurrent(topEl, top.name, isCurrentParent);
    topEl.onclick = () => finish(top.id, null);
    list.appendChild(topEl);
    for (const kid of kids.filter((k) => k.parentId === top.id)) {
      const kidEl = document.createElement('button');
      kidEl.className = 'picker-item picker-sub';
      const isCurrentSub = opts?.currentSubcategoryId === kid.id;
      applyCurrent(kidEl, `${top.name} / ${kid.name}`, isCurrentSub);
      kidEl.onclick = () => finish(top.id, kid.id);
      list.appendChild(kidEl);
    }
  }

  if (firstCurrentRow && typeof (firstCurrentRow as HTMLElement).scrollIntoView === 'function') {
    (firstCurrentRow as HTMLElement).scrollIntoView({ block: 'center' });
  }

  const close = () => backdrop.remove();
  backdrop.querySelector<HTMLButtonElement>('#picker-close')!.onclick = close;
  backdrop.addEventListener('click', (e) => {
    if (e.target === backdrop) close();
  });

  function finish(categoryId: string, subcategoryId: string | null): void {
    backdrop.remove();
    onPick(categoryId, subcategoryId);
  }
}
